import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// css
import styles from "./AppoitnmentDetail.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { APPOINTMENT_INVOICE_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useCreateAppointmentInvoiceMutation, useGetAppointmentAssessmentListQuery, useSendAppointmentInvoiceMutation, useSendAppointmentRecieptMutation, useUpdateAppointmentConsentFormStatusMutation, useUpdateAppointmentMutation, useUpdateAppointmentPriceMutation } from "store/services/appointment";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateTimeFormat, successMessageToast } from "helpers/common";
import { useFileViewer } from "hooks/useFileViewer";
import { useDispatch, useSelector } from "react-redux";
import { useGetApptInvoiceDetailQuery } from "store/services/appointmentInvoices";
import LoadingButton from "components/shared/LoadingButton";

const AppointmentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [assessmentOptions, setAssessmentOptions] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [modalType, setModalType] = useState(null)
  const [currentEntry, setCurrentEntry] = useState(null)
  const [appointmentPrice, setAppointmentPrice] = useState(0)
  const [therapistOptions, setTherapistOptions] = useState([])
  const [currentAssignedTherapist, setCurrentAssignedTherapist] = useState(null)
  const { handleViewPdf, getFileLoading } = useFileViewer();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.chatterProgramProfilesFilter);
  const [currentChatter, setCurrentChatter] = useState(null)
  const [assignModal, setAssignModal] = useState(false)

  const { data: assessmentProgramList, isFetching: assessmentProgramListFetching } = useGetAppointmentAssessmentListQuery();
  const [updateConsentFormStatus, { isLoading: consenFormStatusLoading }] = useUpdateAppointmentConsentFormStatusMutation()
  const [updateAppointment, { isLoading: updateAppointmentLoading }] = useUpdateAppointmentMutation()
  const [updateApptPrice, { isLoading: updateApptPriceLoading }] = useUpdateAppointmentPriceMutation()
  const [createInvoice, { isLoading: createInvoiceLoading }] = useCreateAppointmentInvoiceMutation()
  const [sendInvoice, { isLoading: sendInvoiceLoading }] = useSendAppointmentInvoiceMutation()
  const [sendReciept, { isLoading: sendRecieptLoading }] = useSendAppointmentRecieptMutation()

  const { data, isLoading, isError, isFetching } = useGetApptInvoiceDetailQuery(id);
  const invoice = data?.program;
  const appointment = data?.program?.invoiceAppointmentAssociation[0];

  const handleCreateInvoice = async () => {
    try {
      const data = await createInvoice({ id }).unwrap()
      successMessageToast(data?.message)
    } catch (error) {
      console.log("Error sending invoice", error)
    }
  }
  const handleSendInvoice = async () => {
    try {
      const data = await sendInvoice({ id }).unwrap()
      successMessageToast(data?.message)
    } catch (error) {
      console.log("Error sending invoice", error)
    }
  }
  const handleSendReciept = async () => {
    try {
      const data = await sendReciept({ id }).unwrap()
      successMessageToast(data?.message)
    } catch (error) {
      console.log("Error sending invoice", error)
    }
  }

  const updateConsentForm = async () => {
    try {
      const data = await updateConsentFormStatus({ id: currentEntry?.formAssigned?.[0]?.id, status: "verified", apptId: id }).unwrap()
      successMessageToast(data?.message)
      setShowModal(false)
    } catch (error) {
      console.log('Error updating consent form status', error)
      setShowModal(false)
    }
  }

  const updatePrice = async () => {
    const body = {
      price: appointmentPrice
    }
    try {
      const result = await updateApptPrice({ id, body }).unwrap()
      successMessageToast(result.message);
    } catch (error) {
      console.log("error updating price")
    }
  }

  return (
    <>
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>

          <Row>
            <Col
              lg="12"
              className=""
              style={{ borderRight: "1px solid #3da0aa4f" }}
            >
              <Row>
                <Col lg="12" className="my-3">
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold back-to-btn"
                            to={APPOINTMENT_INVOICE_LIST}
                          >
                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                            </svg> Back
                          </Link>
                        </li>
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold"
                            style={{ textDecoration: "underline" }}
                            to={APPOINTMENT_INVOICE_LIST}
                          >
                            Invoices
                          </Link>
                        </li>
                        <li className="">
                          <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                        </li>
                      </ul>
                    </div>

                    <div className="right">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                        <li className="">

                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                {isLoading ? (
                  <LoadingIndicator />
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <Col lg="12" className="my-3">
                    {(isFetching) && (
                      <LoadingOverlay />
                    )}
                    <Row>
                      <Col md="4" sm="4" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Invoice Date
                          </h6>
                          <p className="m-0 forteen themeBlue pt-2">{dateTimeFormat(invoice?.invoice_date)}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Appointment Title
                          </h6>
                          <p className="m-0 forteen themeBlue pt-2">{appointment?.title || "--"}</p>
                        </div>
                      </Col>
                      <Col md="6" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Appointment Description
                          </h6>
                          <p className="m-0 forteen themeBlue pt-2">{appointment?.description || "--"}</p>
                        </div>
                      </Col>
                      <Col md="12" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Additional Notes
                          </h6>
                          <p className="m-0 forteen themeBlue pt-2 text-capitalize">{appointment?.record?.additional_notes || "--"}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" className="my-2">
                        <div className="d-flex gap-2">
                          <LoadingButton
                              className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                          >
                            Send Invoice
                          </LoadingButton>
                          <LoadingButton
                              className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                          >
                            Send Receipt
                          </LoadingButton>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

const singleParent = {
  firstname: "",
  lastname: "",
  phone: "",
  email: ""
}

export default AppointmentDetail;
